// Library
import { configureStore, combineReducers } from "@reduxjs/toolkit";

// Reducers
import userReducer from "./Reducers/User/userSlice";
import filterReducer from "./Reducers/User/filterSlice";
import { State } from "./Reducers/types";

function saveToLocalStorage(state: State) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (e) {
    console.warn(e);
  }
};

function loadFromLocalStorage() {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState) as State;
  } catch (e) {
    console.warn(e);
    return undefined;
  }
};

export function createReduxStore() {
  const combinedReducer = combineReducers({
    user: userReducer,
    filter: filterReducer
  });

  const store = configureStore({
    reducer: combinedReducer,
    // devTools: false,
    preloadedState: loadFromLocalStorage(),
  });
  store.subscribe(() => saveToLocalStorage(store.getState()));
  return store;
}

// export default configureStore({
//   reducer: {
//       user: userReducer,
//       products: productReducer
//   }
// })
